import type { ListPopoverItemProps } from './index.types';
import { Icon } from 'Components/shared/Icon';
import React from 'react';
import { cn } from '~/lib/utils';

export const ListPopoverItem: React.FC<ListPopoverItemProps> = ({
  text,
  icon,
  testId,
  isSelected,
  destructive,
  disabled,
  onClick,
}) => {
  const isDisabled = disabled?.condition ?? false;

  return (
    <button
      type="button"
      data-testid={testId}
      disabled={isDisabled}
      title={isDisabled ? disabled.title : undefined}
      className={cn(
        'p-[9px] rounded-lg cursor-pointer text-[14px] text-start text-foreground leading-[14px] font-normal flex items-center justify-between w-full hover:bg-muted',
        {
          'font-bold py-[4px]': isSelected,
          'cursor-not-allowed opacity-50': isDisabled,
          'text-destructive-light': destructive,
        }
      )}
      onClick={onClick}
    >
      <span className="flex items-center gap-2">
        {icon && <Icon icon={icon} className="size-[24px]" />}
        {text}
      </span>
      {isSelected && (
        <Icon icon="check" className="size-[24px]" testId="popover-check-icon" />
      )}
    </button>
  );
};
